'use strict';

const jcs = require('../../jcs');
const React = require('react');
const DATA_CENTERS = require('../../../../src/constants').DATA_CENTERS;

function EventProfilesController(
  $scope,
  $routeParams,
  $timeout,
  $http,
  $q,
  $window,
  $location,
  focus,
  httpService,
  webPlayerService,
  webEventProfileService,
  formValidationService,
  eventService,
  Authentication
) {
  'ngInject';

  $(window).trigger('resize'); // ensure footer is properly positioned

  $scope.validation = formValidationService.init();

  $scope.WEB_PROFILE_NAME_MAX_LENGTH = 46; // limit is 50, but backend adds 4 characters to ensure uniqueness

  $scope.is_working = false;
  $scope.error_msg = null;

  $scope.delete_after_options = [
    {value: 1, name: "1 Day"},
    {value: 2, name: "2 Days"},
    {value: 3, name: "3 Days"},
    {value: 4, name: "4 Days"},
    {value: 5, name: "5 Days"},
    {value: 6, name: "6 Days"},
    {value: 7, name: "7 Days"},
    {value: 8, name: "8 Days"},
    {value: 9, name: "9 Days"},
    {value: 10, name: "10 Days"},
    {value: 11, name: "11 Days"},
    {value: 12, name: "12 Days"},
    {value: 13, name: "13 Days"},
    {value: 14, name: "14 Days"},
    {value: 15, name: "15 Days"},
  ];
  $scope.DELETE_AFTER_DEFAULT = 6;

  $scope.type_options = [webEventProfileService.TYPE_PUBLIC, webEventProfileService.TYPE_RETURN_FEED, webEventProfileService.TYPE_SOCIAL];

  // regions
  $scope.region_options = DATA_CENTERS.map((dataCenter) => {
    return {value: dataCenter.id, name: dataCenter.displayName};
  });
  $scope.is_manual_region = false;

  // web event profile to create
  $scope.name = '';
  $scope.description = '';
  $scope.type = webEventProfileService.TYPE_PUBLIC.value;
  $scope.delete_after = $scope.DELETE_AFTER_DEFAULT;
  $scope.region = null;

  $scope.getCurrentUser = function () {
    return Authentication.getCurrentUser();
  };

  $scope.cancel = function () {
    $location.url('/eventprofiles');
  };

  $scope.editRegion = function () {
    $scope.is_manual_region = true;
  };

  $scope.saveNewWebEventProfile = function () {

    $scope.validation.clear();

    // if we have form validation errors, then don't go any further
    if ($scope.doesSaveNewWebEventProfileFailValidation()) {
      return false;
    }

    const newProfileData = {
      name: $scope.name,
      description: $scope.description,
      regionId: $scope.region,
      loadBalPrefix: null,
      deleteAfter: $scope.delete_after,
      type: $scope.type,
      dvrWindowSeconds: null,
      chromeCastAppId: null,
      branded: false,
    };

    $scope.is_working = true;

    httpService.post(`${jcs.api.url_v3}/customers/${Authentication.getCurrentUser().customerID}/webeventprofiles`, newProfileData, {withCredentials: true},
      () => { // success
        $scope.error_msg = null;
        $location.url('/eventprofiles');
      },
      (reason) => { // error
        $scope.error_msg = {
          message: 'An error occurred while attempting to create the web event profile. Please try again, or report the problem if it persists.',
          reason: reason
        };
      },
      () => { // finally
        $scope.is_working = false;
      });
  };

  $scope.doesSaveNewWebEventProfileFailValidation = function () {

    $scope.error_msg = null;
    $scope.validation.clear();

    // ensure required fields are not empty
    $scope.validation.checkForEmpty('name', $scope.name);
    $scope.validation.checkForEmpty('type', $scope.type);
    $scope.validation.checkForEmpty('description', $scope.description);

    $scope.validation.checkForEmpty('region', $scope.region);

    let hasValidationError = $scope.validation.hasError();
    if (hasValidationError) {
      $scope.error_msg = 'Please specify a value for the highlighted fields below.';
    }

    // if no "required field" errors, then ...
    if (!hasValidationError) {
      // only allow letters, numbers, spaces, underscores, and dashes for profile name
      const name_restricted_chars = /[^a-zA-Z0-9\-\_ ]+/g;
      if (name_restricted_chars.test($scope.name)) {
        hasValidationError = true;
        $scope.validation.setError('name');
        $scope.error_msg = 'The "Profile Name" contains some invalid characters. The name may only contain letters, numbers, spaces, underscores, and dashes.';
      }
    }

    return hasValidationError;
  };

  $scope.onRegionFound = function(latencyDetails) {
    if (!$scope.is_manual_region && latencyDetails && latencyDetails.dataCenter) {
      $scope.region = latencyDetails.dataCenter.id;
    }
  }

  // build our tooltips
  $timeout(function () {
    // tooltip for "type" that shows on web event profile details page (customers can see this)
    $('.web-event-profile-type-customer-tooltip').tooltip({
      template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner tooltip-inner-wide tooltip-inner-left"></div></div>',
      placement: 'top',
      title: '<div class="tooltip-section">Public: for use with your regular online audience</div><div class="tooltip-section">Return Feed: for limited internal viewing only</div>Social: for use when only streaming to social media',
      html: true,
    });
    $timeout(function () {
      $('[data-toggle="tooltip"]').tooltip(); // needs to be done in timeout, otherwise for some reason the tooltip gets built before angular does it's magic
    });
  });

}

module.exports = EventProfilesController;
